import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'howden-help-risk',
  templateUrl: './help-risk.component.html',
  styleUrls: ['./help-risk.component.scss'],
  imports: [CdkScrollable, NgClass, MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class HelpRiskComponent {
  data = inject(MAT_DIALOG_DATA);

  public example = '';
  public withExample = false;

  constructor() {
    const data = this.data;

    if (data) {
      this.example = data.risk.example;
      if (this.example === '') {
        this.withExample = false;
      } else {
        this.withExample = true;
      }
    }
  }
}
